import depositMatchOffer from "./deposit-match-offer";
import pricePromotions from "./price-promotions";
import list from "./list";
const promotionsModule = {
  namespaced: true,
  modules: {
    "deposit-match-offer": depositMatchOffer,
    list,
    "price-promotions": pricePromotions,
  },
};

export default promotionsModule;
